import React, { useEffect, useMemo, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import Header from "../../../../components/Header";
import Container from "../../../../componentsv2/Container";
import Paper from "../../../../componentsv2/Paper";
import Button from "../../../../componentsv2/Button";
import Box from "../../../../componentsv2/Box";
import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import { Input } from "../../../../componentsv2/Input";
import { api } from "../../../../services/Api";
import getApiErrorMessage from "../../../../utils/getApiErrorMessage";
import ModalConfirmacaoAcao from "../../Components/ModalConfirmacaoAcao";
import ModalOpcoesEnfermeiro from "./components/ModalOpcoesEnfermeiro";
import ModalCadastroEnfermeiro from "./components/ModalCadastroEnfermeiro";
import EnfermeirosTabela from "./components/EnfermeirosTabela";

export default function EnfermeirosAgendaCare() {
  const history = useHistory();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState("");
  const [openModalCadastro, setOpenModalCadastro] = useState(false);
  const [openModalOpcoes, setOpenModalOpcoes] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [rowSelecionada, setRowSelecionada] = useState(null);

  const carregarEnfermeiros = async () => {
    setLoading(true);
    try {
      const {
        data: { data },
      } = await api.get("/v2/agendaCare/enfermeiros");

      const formatado = (data || []).map(item => ({
        ...item,
        nome: item?.usuario?.funcionario?.nome_usu || item?.usuario?.funcionarios?.nome_usu || "",
        username: item?.usuario?.username || "",
      }));
      setRows(formatado);
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, "Erro ao carregar enfermeiros."), { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarEnfermeiros();
  }, []);

  const salvarNovoEnfermeiro = async ({ usuarioId }) => {
    try {
      const idNum = Number(usuarioId);
      if (!Number.isInteger(idNum) || idNum <= 0) {
        enqueueSnackbar("Escolha um login na lista.", { variant: "warning" });
        return;
      }
      await api.post("/v2/agendaCare/enfermeiros", { usuarioId: idNum });
      enqueueSnackbar("Enfermeiro registado.", { variant: "success" });
      setOpenModalCadastro(false);
      carregarEnfermeiros();
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, "Erro ao registar."), { variant: "error" });
    }
  };

  const excluir = async () => {
    if (!rowSelecionada?.id) {
      return;
    }
    try {
      await api.delete(`/v2/agendaCare/enfermeiro/${rowSelecionada.id}`);
      enqueueSnackbar("Enfermeiro inativado.", { variant: "success" });
      carregarEnfermeiros();
      setOpenModalConfirmacao(false);
      setRowSelecionada(null);
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, "Erro ao inativar."), { variant: "error" });
    }
  };

  const abrirModalOpcoes = row => {
    setRowSelecionada(row);
    setOpenModalOpcoes(true);
  };

  const fecharModalOpcoes = () => {
    setOpenModalOpcoes(false);
  };

  const visualizar = () => {
    const id = rowSelecionada?.id;
    if (!id) {
      return;
    }
    history.push(`/agendaCare/enfermeiros/visualizar/${id}`);
    setOpenModalOpcoes(false);
  };

  const excluirSelecionado = () => {
    if (!rowSelecionada) {
      return;
    }
    setOpenModalOpcoes(false);
    setOpenModalConfirmacao(true);
  };

  const rowsFiltradas = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    if (!termo) {
      return rows;
    }
    return rows.filter(row => {
      const nome = row?.nome?.toLowerCase() || "";
      const username = row?.username?.toLowerCase() || "";
      return nome.includes(termo) || username.includes(termo);
    });
  }, [rows, busca]);

  return (
    <>
      <Header titulo="Enfermeiros" />
      <Container>
        <Paper style={{ marginTop: "10px", padding: "1rem" }} elevation={2}>
          <GridContainer spacing={2}>
            <GridItem xs={12}>
              <Button onClick={() => history.push("/agendaCare")}>
                <ArrowBackIcon style={{ color: "#003399" }} />
              </Button>
            </GridItem>
            <GridItem xs={12}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", md: "minmax(280px, 1fr) 180px" },
                  alignItems: "end",
                  gap: 2,
                }}
              >
                <Input
                  label="Pesquisar"
                  variant="standard"
                  fullWidth
                  value={busca}
                  onChange={event => setBusca(event.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ color: "#8a919b" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  color="blue"
                  onClick={() => setOpenModalCadastro(true)}
                  style={{ width: "100%" }}
                >
                  Cadastrar
                </Button>
              </Box>
            </GridItem>
            <GridItem xs={12}>
              <EnfermeirosTabela rows={rowsFiltradas} loading={loading} onAbrirOpcoes={abrirModalOpcoes} />
            </GridItem>
          </GridContainer>
        </Paper>
        <ModalCadastroEnfermeiro
          open={openModalCadastro}
          onClose={() => setOpenModalCadastro(false)}
          onSalvar={salvarNovoEnfermeiro}
        />
        <ModalOpcoesEnfermeiro
          open={openModalOpcoes}
          onClose={fecharModalOpcoes}
          onVisualizar={visualizar}
          onExcluir={excluirSelecionado}
        />
        <ModalConfirmacaoAcao
          open={openModalConfirmacao}
          onCancelar={() => setOpenModalConfirmacao(false)}
          onConfirmar={excluir}
          titulo="Inativar enfermeiro"
          descricao="Confirmar inativação?"
          textoConfirmar="Confirmar"
        />
      </Container>
    </>
  );
}
